import React, { useEffect, useState } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
} from "@mui/material";
import { StyledButton } from "../../../common/components/Button";
import { StyledDialog } from "../../../common/components/Dialog";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { serviceProviderScheduleSchema } from "../schemas/serviceProviderScheduleSchema";
import { addServiceProviderSchedule } from "../../../api/scheduleApi";
import { TimeInput } from "../../../common/components/Input";
import dayjs from "dayjs";
import { Snackbar, Alert } from "@mui/material";
const AddServiceProviderScheduleDialog = ({
  openAddSchedule,
  handleCloseAddSchedule,
  currentServiceProvider,
  fetchServiceProviderSchedules,
}) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(serviceProviderScheduleSchema),
    defaultValues: {
      day: "",
      serviceProviderId: "",
      startTime: "",
      endTime: "",
    },
  });
  const [openAlertSnackBar, setOpenAlertSnackBar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleOpenAlert = () => {
    setOpenAlertSnackBar(true);
  };

  const handleCloseAlert = () => {
    setOpenAlertSnackBar(false);
  };

  const handleSetAlertMessage = (message, isSuccess) => {
    setAlertMessage(message);
  };
  useEffect(() => {
    let defaultValues = {};
    defaultValues.serviceProviderId = currentServiceProvider.id;
    reset({ ...defaultValues });
  }, [currentServiceProvider.id, reset]);

  const submitAddSchedule = async (values) => {
    values.startTime = dayjs(values.startTime).format("1900-01-01[T]HH:mm");
    values.endTime = dayjs(values.endTime).format("1900-01-01[T]HH:mm");
    const response = await addServiceProviderSchedule(values);
    if (response.data.error != null) {
      handleSetAlertMessage(response.data.error.message);
      handleOpenAlert();
    } else {
      handleCloseAddSchedule();
      await fetchServiceProviderSchedules();
      reset();
    }
  };

  return (
    <StyledDialog
      open={openAddSchedule}
      onClose={handleCloseAddSchedule}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Add Service Provider Schedule</DialogTitle>
      <form onSubmit={handleSubmit(submitAddSchedule)}>
        <DialogContent dividers>
          <Grid container direction="column">
            <Grid item xs={8}>
              <FormControl
                sx={{
                  m: 1,
                  minWidth: 260,
                  marginBottom: "20px",
                  width: "100%",
                }}
              >
                <InputLabel>Day</InputLabel>
                <Select
                  label="Day"
                  error={errors.day}
                  helperText={errors.day?.message}
                  {...register("day")}
                >
                  <MenuItem value={"Monday"}>Monday</MenuItem>
                  <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                  <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                  <MenuItem value={"Thursday"}>Thursday</MenuItem>
                  <MenuItem value={"Friday"}>Friday </MenuItem>
                  <MenuItem value={"Saturday"}>Saturday</MenuItem>
                  <MenuItem value={"Sunday"}>Sunday</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TimeInput
                label="Start Time"
                name="startTime"
                control={control}
              />
            </Grid>

            <Grid item xs={8}>
              <TimeInput label="End Time" name="endTime" control={control} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <StyledButton theme="green" type="submit" disabled={isSubmitting}>
            Submit
          </StyledButton>
        </DialogActions>
      </form>
      <Snackbar
        open={openAlertSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert
          variant="filled"
          onClose={handleCloseAlert}
          severity={"error"}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </StyledDialog>
  );
};
export default AddServiceProviderScheduleDialog;
